import type { AuthMe, SessionUser } from "@icraftx/shared/v1";
import { apiDelete, apiGet, apiPost } from "./client";

export type AuthStatus = {
  googleConfigured: boolean;
  sessionConfigured: boolean;
  databaseConfigured: boolean;
  devBypass: boolean;
  superadminEmail: string;
  googleClientId: string | null;
};

export function fetchAuthStatus() {
  return apiGet<AuthStatus>("/auth/status");
}

export function fetchMe() {
  return apiGet<AuthMe>("/auth/me");
}

export function loginWithGoogle(idToken: string) {
  return apiPost<AuthMe>("/auth/google", { idToken });
}

export function loginDev(email: string) {
  return apiPost<AuthMe>("/auth/dev-login", { email });
}

export function logout() {
  return apiPost<{ ok: boolean }>("/auth/logout");
}

/** Cashier code + PIN — requires host session already in company (plan/19). */
export function loginWithPin(body: {
  companyRef: string;
  userCode: string;
  pin: string;
}) {
  return apiPost<{
    user: SessionUser;
    company: { id: string; slug: string; name: string };
    userCode: string | null;
    permissionKeys?: string[];
  }>("/auth/pin/login", body);
}

export function createCompany(input: {
  name: string;
  slug: string;
  ownerEmail?: string;
  branchName?: string;
  branchSlug?: string;
}) {
  return apiPost<{
    company: { id: string; slug: string; name: string };
    branch: { id: string; slug: string; name: string };
    ownerUserId: string;
  }>("/superadmin/companies", input);
}

export function listPlatformCompanies() {
  return apiGet<{
    companies: Array<{
      id: string;
      slug: string;
      name: string;
      status: string;
      currencyCode: string;
      timezone: string;
      taxPriceMode: string;
      taxRatePct?: string;
      discountSoftCapPct: number;
    }>;
  }>("/superadmin/companies");
}

export type PlatformOperator = {
  id: string;
  email: string | null;
  displayName: string | null;
  seed: boolean;
};

export function listPlatformOperators() {
  return apiGet<{ operators: PlatformOperator[] }>("/superadmin/operators");
}

export function grantPlatformOperator(email: string) {
  return apiPost<{ operator: PlatformOperator }>("/superadmin/operators", {
    email,
  });
}

export function revokePlatformOperator(userId: string) {
  return apiDelete<{ ok: boolean }>(`/superadmin/operators/${userId}`);
}
